export const theme = {
  '1': {
    imgUrl: 'tw',
    hasLogo: true,
    theme: {
      dark: '#f5bd10',
      light: '#fff1cd'
    },
    menu: [{
      title: '账号',
      type: 'user'
    }, {
      title: '礼包',
      type: 'gift'
    }, {
      title: '公告',
      type: 'notice'
    }, {
      title: '资讯',
      type: 'news'
    }, {
      title: '客服',
      type: 'customer'
    }],
    gameName: 'tanwan',
    apiName: 'www.tanwan'
  },
  '2': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    },
    menu: [{
      title: '账号',
      type: 'user'
    }, {
      title: '礼包',
      type: 'gift'
    }, {
      title: '公告',
      type: 'notice'
    }, {
      title: '客服',
      type: 'customer'
    }],
    gameName: '695716',
    apiName: 'www.695716'
  },
  '3': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    },
    menu: [{
      title: '账号',
      type: 'user'
    }, {
      title: '客服',
      type: 'customer'
    }],
    gameName: 'qutongwl',
    apiName: 'face.qutongwl'
  },
  '4': {
    imgUrl: 'tw',
    hasLogo: true,
    theme: {
      dark: '#f5bd10',
      light: '#fff1cd'
    },
    menu: [],
    gameName: 'tanwan',
    apiName: 'www.tanwan'
  },
  '5': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    },
    menu: [],
    gameName: '695716',
    apiName: 'www.695716'
  },
  '6': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    },
    menu: [{
      title: '账号',
      type: 'user'
    }, {
      title: '礼包',
      type: 'gift'
    }, {
      title: '公告',
      type: 'notice'
    }, {
      title: '客服',
      type: 'customer'
    }],
    gameName: 'xitwxi',
    apiName: 'wwwapi.xitwxi'
  },
  '7': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    },
    menu: [{
      title: '账号',
      type: 'user'
    }, {
      title: '礼包',
      type: 'gift'
    }, {
      title: '公告',
      type: 'notice'
    }, {
      title: '客服',
      type: 'customer'
    }],
    gameName: 'nafeini',
    apiName: 'wwwapi.nafeini'
  }
}
